import prettier from 'prettier/standalone';
import plugins from 'prettier/parser-babylon';
import { removeUnprintableChar } from '../utils';
export class JSONFormatter {
    getFormatted(rawText, options = JSONFormatter.defaultOptions) {
        let t = rawText;
        try {
            t = prettier.format(rawText, options);
        }
        catch (error) {
            // 
        }
        return t;
    }
    getRaw(formattedText) {
        return removeUnprintableChar(formattedText);
    }
}
JSONFormatter.defaultOptions = { parser: 'json', plugins: [plugins] };
export default new JSONFormatter();
